const SETTINGS_KEY = 'allergoaway_reminders';

export interface ReminderSettings {
  enabled: boolean;
  morningTime: string; // "HH:MM"
  eveningTime: string; // "HH:MM"
}

export function getReminderSettings(): ReminderSettings {
  try {
    const s = localStorage.getItem(SETTINGS_KEY);
    if (s) return JSON.parse(s);
  } catch {}
  return { enabled: false, morningTime: '08:00', eveningTime: '20:30' };
}

export function saveReminderSettings(settings: ReminderSettings): void {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
}

export async function requestPermission(): Promise<boolean> {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const result = await Notification.requestPermission();
  return result === 'granted';
}

export function hasNotificationSupport(): boolean {
  return 'Notification' in window && 'serviceWorker' in navigator;
}

// Notification Triggers API (Chrome 80+, experimental)
function hasTriggersAPI(): boolean {
  return typeof (window as any).TimestampTrigger !== 'undefined';
}

function nextTriggerTime(timeStr: string): Date {
  const [h, m] = timeStr.split(':').map(Number);
  const now = new Date();
  const t = new Date();
  t.setHours(h, m, 0, 0);
  if (t.getTime() <= now.getTime()) t.setDate(t.getDate() + 1);
  return t;
}

export async function scheduleReminders(settings: ReminderSettings): Promise<void> {
  if (!hasNotificationSupport()) return;
  if (Notification.permission !== 'granted') return;

  const reg = await navigator.serviceWorker.ready;

  // Cancel previously scheduled reminders
  const existing = await reg.getNotifications({ tag: 'allergoaway-morning' });
  existing.forEach(n => n.close());
  const existing2 = await reg.getNotifications({ tag: 'allergoaway-evening' });
  existing2.forEach(n => n.close());

  if (!settings.enabled) return;

  const slots = [
    { tag: 'allergoaway-morning', time: settings.morningTime, label: 'mattina' },
    { tag: 'allergoaway-evening', time: settings.eveningTime, label: 'sera' },
  ];

  for (const slot of slots) {
    const triggerTime = nextTriggerTime(slot.time);
    const options: NotificationOptions & { showTrigger?: unknown } = {
      body: 'Registra i tuoi sintomi allergici di ' + slot.label,
      icon: '/logo192.png',
      badge: '/favicon.svg',
      tag: slot.tag,
      renotify: true,
    };

    if (hasTriggersAPI()) {
      // Schedule in advance — browser will show it even if app is closed
      options.showTrigger = new (window as any).TimestampTrigger(triggerTime.getTime());
      await reg.showNotification('AllergoAway', options);
    } else {
      // Fallback: fire via setTimeout (only if app/tab stays open)
      const delay = triggerTime.getTime() - Date.now();
      setTimeout(() => {
        reg.showNotification('AllergoAway', options);
      }, delay);
    }
  }
}
